import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';
import { BaseReportService } from '../../shared/_utils/services/base-report-service';
import { Observable } from 'rxjs/Observable';
import { tap} from 'rxjs/operators';
import { catchError  } from 'rxjs/operators';
import { PettyCashDTO } from '../model/petty-cash-dto';
import { ParamsReportPettyCash } from '../model/params-report-petty-cash';

@Injectable()
export class ReportPettyCashService extends BaseReportService<PettyCashDTO> {
    
  buildSentence(entity?: PettyCashDTO, event?: LazyLoadEvent): HttpParams {
      throw new Error('Method not implemented.');
  }

  public uri = '/api/reportPettyCash/';

  constructor(injector: Injector) {
    super(injector);
    console.log('Instance ReportPettyCashService');
  }

  searchToViewTable( paramsReportPettyCash : ParamsReportPettyCash): Observable<any> {
         this.spinnerService.showAll();
        const url = `${this.rutaServidor}${this.uri}search`; 
        return this.httpClient.post<any>(url, paramsReportPettyCash  )
        .pipe(
          tap(response => {
            return response;
          }, 
           err =>{
            this.spinnerService.hideAll();
           this.notificationService.serverErrorMessage(err.status +' - '+ err.error.messages[0]);
            return new Observable<any>();
          },
           ()=>{
             this.spinnerService.hideAll();
           })
           ,
            catchError((err) => {
               return new Observable<Blob>();
           })
           
          ) ;
  } 
}



// WEBPACK FOOTER //
// ./src/app/core/services/report-petty-cash.service.ts